import { Suspense, lazy } from 'react';

import { SearchFilterShimmer } from './SearchFilterShimmer';
export * from './util';

const LazyFilter = lazy(async () => {
  await new Promise(r => setTimeout(() => r(undefined), 46));
  return import('./SearchFilter').then(m => ({
    default: m.SearchFilter,
  }));
});

export const SearchFilter = props => (
  <Suspense fallback={<SearchFilterShimmer />}>
    <LazyFilter {...props} />
  </Suspense>
);

export { SearchFilterShimmer };
